import { render, staticRenderFns } from "./ArthriticPain.vue?vue&type=template&id=717f2d62&scoped=true"
import script from "./ArthriticPain.vue?vue&type=script&lang=js"
export * from "./ArthriticPain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717f2d62",
  null
  
)

export default component.exports